const rewards = {
  bronze: [
    { minItems: 3, percent: 5, code: 'BUNDLE5BRONZE' },
    { minItems: 5, percent: 10, code: 'BUNDLE10RONZE' },
    { minItems: 6, percent: 15, code: 'BUNDLE15BRONZE' }
  ],
  silver: [
    { minItems: 3, percent: 7, code:  'BUNDLE7SILVER' },
    { minItems: 5, percent: 12, code: 'BUNDLE12SILVER' },
    { minItems: 6, percent: 17, code: 'BUNDLE17SILVER' }
  ],
  gold: [
    { minItems: 3, percent: 10, code: 'BUNDLE10GOLD' },
    { minItems: 5, percent: 15, code: 'BUNDLE15GOLD' },
    { minItems: 6, percent: 20, code: 'BUNDLE20GOLD' }
  ]
};


window.fixSlidecartHeaderMargin = function() {
  var header = document.querySelector('#slidecarthq .header');
  if (header) {
    header.style.setProperty('margin', '0px', 'important');
  }
};



function getCurrentTier() {
  const tier = (window.smileVIPTier || '').toLowerCase();
  if (['gold', 'silver', 'bronze'].includes(tier)) return tier;
  return null; // <--- jetzt KEIN Default mehr!
}


function getCurrentReward(tier, itemCount) {
  const tierRewards = rewards[tier];
  for (let i = tierRewards.length - 1; i >= 0; i--) {
    if (itemCount >= tierRewards[i].minItems) {
      return tierRewards[i];
    }
  }
  return null;
}

let lastAppliedDiscount = null;

function autoApplyBundleDiscount(cart) {
  // 1. Alle gültigen Bundle-Codes ermitteln
  const allBundleCodes = Object.values(rewards).flat().map(r => r.code);

  // 2. Alle aktuell im Cart gesetzten Rabattcodes holen
  const activeCodes = (cart.discount_codes || []).map(dc => dc.code);

  // 3. Nur die "fremden" Codes merken (keine Bundle-Codes)
  const nonBundleCodes = activeCodes.filter(code => !allBundleCodes.includes(code));
  console.log('NON  Bundle Codes gefunden:', nonBundleCodes);

  // 4. Den aktuellen gewünschten Bundle-Code ermitteln
  const tier = getCurrentTier();
  const itemCount = getTotalItemCount(cart.items);
  const reward = getCurrentReward(tier, itemCount);
  const bundleCode = reward ? reward.code : null;

  // 5. Zuerst alle "fremden" Codes (nacheinander) setzen
  nonBundleCodes.forEach(code => {
    window.SLIDECART_APPLY_DISCOUNT(code);
    console.log(`Fremden Rabattcode angewendet: ${code}`);
  });

  // 6. Bundle-Code setzen, falls vorhanden
  if (bundleCode) {
    window.SLIDECART_APPLY_DISCOUNT(bundleCode);
    console.log(`Bundle Rabattcode angewendet: ${bundleCode}`);
  }
}



function getNextReward(tier, itemCount) {
  const tierRewards = rewards[tier];
  for (let i = 0; i < tierRewards.length; i++) {
    if (itemCount < tierRewards[i].minItems) {
      return tierRewards[i];
    }
  }
  return null;
}

function expandCartItems(cartItems) {
  const expanded = [];
  cartItems.forEach(item => {
    for (let i = 0; i < item.quantity; i++) {
      expanded.push(item);
    }
  });
  return expanded;
}

function getTotalItemCount(cartItems) {
  const count = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  return count;
}

function getBundleTitle(itemCount, rewardsForTier) {
  let nextReward = null;
  for (let i = 0; i < rewardsForTier.length; i++) {
    if (itemCount < rewardsForTier[i].minItems) {
      nextReward = rewardsForTier[i];
      break;
    }
  }
  if (nextReward) {
    const fehlend = nextReward.minItems - itemCount;
    const produktWort = fehlend === 1 ? 'Produkt' : 'Produkte';
    return `Noch ${fehlend} ${produktWort} für ${nextReward.percent}% Rabatt auf dein Bundle!`;
  } else {
    return `Du bist der Hammer! Du hast alle Rabatte freigeschaltet!`;
  }
}

let slidecartRenderTimeout = null;

window.renderSlidecartBoxes = function () {
  const tier = getCurrentTier();


  if (!tier) {
    // Optional: Hier kannst du statt dessen eine Info anzeigen oder einfach nix tun
    console.log('[DEBUG] Kein berechtigter VIP-Tier (bronze, silver, gold) erkannt – Mix & Match wird NICHT angezeigt.');
    const customBox = document.getElementById('my-slidecart-custom-content');
    if (customBox) customBox.innerHTML = ""; // Löscht evtl. bestehende Boxen
    return;
  }

  // Doppelte Calls in kurzer Zeit verhindern
  if (slidecartRenderTimeout) clearTimeout(slidecartRenderTimeout);
  slidecartRenderTimeout = setTimeout(() => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Debug: Rabattcodes anzeigen
        if (cart.discount_codes && cart.discount_codes.length > 0) {
          cart.discount_codes.forEach((dc, i) => {
            console.log(`[DEBUG] Rabattcode #${i + 1}:`, dc.code, dc);
          });
        } else {
          console.log('[DEBUG] Kein Rabattcode aktuell im cart.discount_codes gefunden.');
        }

        function injectCartBoxes(box, cartItems) {
          const tier = getCurrentTier();
          const rewardsForTier = rewards[tier];
          const totalCount = getTotalItemCount(cartItems);

          const titleText = getBundleTitle(totalCount, rewardsForTier);

          const expandedItems = expandCartItems(cartItems);

          let boxesHTML = '';
          for (let i = 0; i < 6; i++) {
            const rewardForSlot = rewardsForTier.find(r => r.minItems === (i + 1));
            let percentBadge = '';
            if (rewardForSlot) {
              percentBadge = `<span class="percent-badge">${rewardForSlot.percent}%</span>`;
            }
            if (expandedItems[i]) {
              boxesHTML += `<div class="grey-box">${percentBadge}<img src="${expandedItems[i].image}" alt="${expandedItems[i].title}" class="cart-product-img" /></div>`;
            } else {
              boxesHTML += `<div class="grey-box">${percentBadge}</div>`;
            }
          }
          box.innerHTML = `
            <div class="slidecart-boxes-section">
              <h2>${titleText}</h2>
              <div class="boxes-row">
                ${boxesHTML}
              </div>
            </div>
          `;
        }

        function tryInject(cartItems) {
          const customBox = document.getElementById('my-slidecart-custom-content');
          if (customBox) {
            injectCartBoxes(customBox, cartItems);
            return true;
          }
          return false;
        }

        if (!tryInject(cart.items)) {
          const observer = new MutationObserver(() => {
            if (tryInject(cart.items)) {
              observer.disconnect();
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
        }

        // Nach Rendering: Bundle Discount prüfen
        autoApplyBundleDiscount(cart);
      });
    slidecartRenderTimeout = null;
  }, 200); // Kurzes Delay, um Ajax-Finish sicher zu sein
};

document.addEventListener('DOMContentLoaded', function () {
  window.renderSlidecartBoxes();
  window.fixSlidecartHeaderMargin();  
});

document.addEventListener('cart:updated', function () {
  console.log('[DEBUG] cart:updated Event ausgelöst, Slidecart-Boxen neu rendern.');
  window.renderSlidecartBoxes();
  window.fixSlidecartHeaderMargin();  
});
